import '../styles/index.scss';

require('@popperjs/core');
require('bootstrap');

if (process.env.NODE_ENV === 'development') {
    require('../index.html');
}

// Navbar-Scroll Sticky
let navbar = document.getElementById("navbar");

window.addEventListener("scroll", () => {
  let scrollPos = window.scrollY;
  if (scrollPos > 50) {
    navbar.classList.add('sticky-navbar');
  } else {
    navbar.classList.remove('sticky-navbar');
  }
});

// Hero - Changing Texts
const texts  = [' ', 'Senior Bug-Creator', 'Web Developer', 'Backend Developer', 'Computer Engineer'];
let order    = -1;
let selected = undefined;

function getNext() {
    order++;
    if (order == texts.length) {
        order = 0;
    }
    return texts[order].split('');
}

function getRandomTime() {
  return Math.random() * 0.5;
}

function getElement() {
  return document.getElementById("hero-text-marker");
}

function ModifyTxt(txt) {
  return (getElement().innerHTML = txt);
}

function writeOut(curChar = 0) {
    if (selected === undefined) {
        selected = getNext();
    }
    setTimeout(function() {
        const el = getElement();
        let elTxt = el.innerHTML;
        elTxt += selected[curChar];
        ModifyTxt(elTxt);
        //check if next iteration is out of range
        if (curChar + 1 == selected.length) {
            return setTimeout(function () { deleteOut(selected.length); }, 1000);
        }
        return writeOut(curChar + 1);
    }, getRandomTime() * 1000);
}

function deleteOut(curChar = 0) {
    setTimeout(function () {
        const el = getElement();
        let elTxt = el.innerHTML;
        const elTxtArr = elTxt.split("");
        const elTxtArrLen = elTxtArr.length;
        const newElTxt = elTxtArr.splice(0, curChar - 1).join("");
        ModifyTxt(newElTxt);
        if (elTxtArrLen == 0) {
            selected = getNext();
            return writeOut(0);
        }
        return deleteOut(elTxtArrLen - 1);
    }, getRandomTime() * 1000);
  return;
}

writeOut();

// Back-to-top Button

const scrollBtn = document.getElementById("go-top-button");

document.addEventListener("scroll", () => {
    if (window.scrollY > 400) {
        scrollBtn.style.visibility = "visible";
    } else {
        scrollBtn.style.visibility = "hidden";
    }
});
scrollBtn.addEventListener("click", () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
});